import { render } from "./TheAdminVideosGrid.vue?vue&type=template&id=d35fe714&ts=true"
import script from "./TheAdminVideosGrid.vue?vue&type=script&lang=ts"
export * from "./TheAdminVideosGrid.vue?vue&type=script&lang=ts"

import "./TheAdminVideosGrid.vue?vue&type=style&index=0&id=d35fe714&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__